<sm-spinner [loading]="loading$"></sm-spinner>
<div class="my-5">
  <!-- page-header -->
  <sm-page-header
    [breadcrumb]="breadcrumb"
    [title]="'paa.variants.inspect_or_edit' | translate: { paa_ref: paaRepository.getNested('response', 'ref') }">
  </sm-page-header>

  <div class="flex flex-row gap-5 items-start">
    <!-- Form -->
    <div class="content w-3/4">
      <sm-form-builder [formObject]="formObject"></sm-form-builder>
      <p-button type="button" label="Retour à la liste" class="mb-4" (click)="router.navigate(['/paa-current-plans'])"></p-button>
    </div>
    <!-- Meta Blocks -->
    <div class="flex flex-col gap-2 w-1/4">
      <sm-status [status]="status" [extra]="paa?.etapeProcess || ''"></sm-status>
      <div class="content h-fit flex flex-col gap-4" *ngFor="let blocks of controlBlocks">
        <sm-block-builder [blocks]="blocks"></sm-block-builder>
      </div>
    </div>
  </div>
</div>
